module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module id = 209
// module chunks = 0